/* eslint-disable max-len */
import { muiColors } from "themes/colors";
import { CustomButton } from "./CustomButton";
import { useTranslate } from "react-admin";
import { Dialog } from "@mui/material";

interface FreeTrialModalProps {
  isFreeTrialDays: number;
  setIsFreeTrialDays: React.Dispatch<React.SetStateAction<number>>;
  setConfirmFreeTrial: React.Dispatch<React.SetStateAction<boolean>>;
  open: boolean;
}

export default function FreeTrialModal({
  isFreeTrialDays,
  setIsFreeTrialDays,
  setConfirmFreeTrial,
  open
}: FreeTrialModalProps) {
  const translate = useTranslate();
  return (
    <Dialog
      title=""
      open={Boolean(open)}
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: muiColors.paper,
          borderRadius: "8px"
        },
        "& #edit-dialog-title": {
          textAlign: "center",
          textTransform: "uppercase",
          fontFamily: "Inter",
          fontSize: "14px"
        },
        "& .RaFormDialogTitle-closeButton": {
          display: "none"
        }
      }}
    >
      <div className="flex flex-col items-center p-4">
        <p>
          {translate("companies.give_free_trial_prefix")}{" "}
          <input
            onChange={(e) => setIsFreeTrialDays(Number(e.target.value))}
            value={isFreeTrialDays}
            className="w-[70px] text-center border rounded px-2 py-1"
          />{" "}
          {translate("companies.give_free_trial_suffix")}
        </p>
        <div className="flex justify-end mt-6 gap-4">
          <CustomButton
            onClick={() => {
              setIsFreeTrialDays(0);
              setConfirmFreeTrial(false);
            }}
            text={translate("common.no")}
            variant="secondary"
          />
          <CustomButton
            onClick={() => {
              setConfirmFreeTrial(false);
            }}
            text={translate("common.yes")}
            sx={{
              backgroundColor: muiColors.button.primary,
              color: muiColors.button.contrast,
              "&:hover": {
                backgroundColor: muiColors.button.primary,
                opacity: 0.9
              }
            }}
          />
        </div>
      </div>
    </Dialog>
  );
}
